import { useTranslation } from 'react-i18next';
import { blogPosts } from '../../../mocks/blog';
import { trackEvent } from '../../../lib/analytics';

export default function BlogPreview() {
  const { t } = useTranslation();
  return (
    <section className="border-b border-border bg-bg">
      <div className="mx-auto max-w-5xl px-5 py-14">
        <div className="flex items-baseline justify-between">
          <div>
            <h2 className="text-[22px] font-semibold tracking-tight">{t('blog.section.title')}</h2>
            <p className="mt-1 text-[14px] text-ink-soft">
              {t('blog.section.subtitle')}
            </p>
          </div>
          <a
            href="/blog"
            className="text-[13px] font-medium text-primary hover:underline cursor-pointer"
          >
            {t('blog.section.allArticles')}
          </a>
        </div>
        <ul className="mt-6 grid gap-4 md:grid-cols-3">
          {blogPosts.slice(0, 3).map((post) => (
            <li key={post.slug}>
              <a
                href={post.slug}
                onClick={() => trackEvent('blog_article_click', {
                  article_slug: post.slug.split('/').pop(),
                  source: 'landing_teaser',
                  transport_type: 'beacon',
                })}
                className="block h-full rounded-lg border border-border bg-surface p-5 transition hover:border-primary cursor-pointer"
              >
                <div className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.08em] text-muted">
                  <span className="rounded-sm bg-primary-soft px-2 py-0.5 text-primary">
                    {t(`blog.${post.key}.category`)}
                  </span>
                  <span>{t(`blog.${post.key}.readTime`)}</span>
                </div>
                <h3 className="mt-2.5 text-[16px] font-semibold leading-[1.35]">{t(`blog.${post.key}.title`)}</h3>
                <p className="mt-1.5 text-[13px] leading-[1.5] text-ink-soft">{t(`blog.${post.key}.excerpt`)}</p>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
